// extracted by mini-css-extract-plugin
export default {"box":"ArticleCardDetails_box__hkduy","detailsBox":"ArticleCardDetails_detailsBox__nvUfD"};